/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * vimotion-api-@@API-SUFFIX
 * MoodMe Engagement Insights Platform
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "https://api.vimotion.mood-me.com/v1/".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
  (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
  url: string;
  options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
  protected configuration?: Configuration;

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected fetch: FetchAPI = isomorphicFetch
  ) {
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
    }
  }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
  name = "RequiredError";
  constructor(public field: string, msg?: string) {
    super(msg);
  }
}

/**
 *
 * @export
 * @interface AttentionEvent
 */
export interface AttentionEvent extends Event {
  /**
   *
   * @type {number}
   * @memberof AttentionEvent
   */
  attention: number;
}
/**
 *
 * @export
 * @interface Client
 */
export interface Client {
  /**
   *
   * @type {number}
   * @memberof Client
   */
  clientId: number;
  /**
   *
   * @type {string}
   * @memberof Client
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Client
   */
  activationDate: string;
  /**
   *
   * @type {string}
   * @memberof Client
   */
  expirationDate: string;
  /**
   *
   * @type {string}
   * @memberof Client
   */
  dateCreated: string;
}
/**
 *
 * @export
 * @interface DefaultResponseData
 */
export interface DefaultResponseData {
  /**
   *
   * @type {string}
   * @memberof DefaultResponseData
   */
  timestamp?: string;
  /**
   *
   * @type {number}
   * @memberof DefaultResponseData
   */
  status?: number;
  /**
   *
   * @type {string}
   * @memberof DefaultResponseData
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof DefaultResponseData
   */
  message?: string;
  /**
   *
   * @type {any}
   * @memberof DefaultResponseData
   */
  data?: any;
}
/**
 *
 * @export
 * @interface EmotionsEvent
 */
export interface EmotionsEvent extends Event {
  /**
   *
   * @type {number}
   * @memberof EmotionsEvent
   */
  surprised: number;
  /**
   *
   * @type {number}
   * @memberof EmotionsEvent
   */
  scared: number;
  /**
   *
   * @type {number}
   * @memberof EmotionsEvent
   */
  disgust: number;
  /**
   *
   * @type {number}
   * @memberof EmotionsEvent
   */
  happy: number;
  /**
   *
   * @type {number}
   * @memberof EmotionsEvent
   */
  sad: number;
  /**
   *
   * @type {number}
   * @memberof EmotionsEvent
   */
  angry: number;
  /**
   *
   * @type {number}
   * @memberof EmotionsEvent
   */
  neutral: number;
}
/**
 *
 * @export
 * @interface Event
 */
export interface Event {
  /**
   *
   * @type {ID}
   * @memberof Event
   */
  sessionEventId: ID;
  /**
   *
   * @type {ID}
   * @memberof Event
   */
  participantId: ID;
  /**
   *
   * @type {string}
   * @memberof Event
   */
  timestamp: string;
  /**
   *
   * @type {ID}
   * @memberof Event
   */
  event: ID;
}
/**
 *
 * @export
 */
export type ID = number;
/**
 *
 * @export
 * @interface Participant
 */
export interface Participant {
  /**
   *
   * @type {ID}
   * @memberof Participant
   */
  participantId: ID;
  /**
   *
   * @type {string}
   * @memberof Participant
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Participant
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof Participant
   */
  note: string;
  /**
   *
   * @type {string}
   * @memberof Participant
   */
  thumbnail: string;
  /**
   *
   * @type {number}
   * @memberof Participant
   */
  ethnicity: number;
  /**
   *
   * @type {number}
   * @memberof Participant
   */
  detectedEthnicity: number;
  /**
   *
   * @type {number}
   * @memberof Participant
   */
  age: number;
  /**
   *
   * @type {number}
   * @memberof Participant
   */
  detectedAge: number;
  /**
   *
   * @type {number}
   * @memberof Participant
   */
  gender: number;
  /**
   *
   * @type {number}
   * @memberof Participant
   */
  detectedGender: number;
  /**
   *
   * @type {number}
   * @memberof Participant
   */
  speakingTime: number;
  /**
   *
   * @type {number}
   * @memberof Participant
   */
  averageEmotions: number;
  /**
   *
   * @type {number}
   * @memberof Participant
   */
  averageAttention: number;
}
/**
 *
 * @export
 * @interface ParticipationEvent
 */
export interface ParticipationEvent extends Event {
  /**
   *
   * @type {number}
   * @memberof ParticipationEvent
   */
  participation: number;
}
/**
 *
 * @export
 * @interface Session
 */
export interface Session {
  /**
   *
   * @type {SessionID}
   * @memberof Session
   */
  sessionId: SessionID;
  /**
   *
   * @type {string}
   * @memberof Session
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Session
   */
  provider: string;
  /**
   *
   * @type {string}
   * @memberof Session
   */
  notes: string;
  /**
   *
   * @type {string}
   * @memberof Session
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof Session
   */
  dateCreated: string;
  /**
   *
   * @type {string}
   * @memberof Session
   */
  dateStart?: string;
  /**
   *
   * @type {string}
   * @memberof Session
   */
  dateEnd?: string;
}
/**
 *
 * @export
 * @interface SessionAggregatedParticipantData
 */
export interface SessionAggregatedParticipantData {
  /**
   *
   * @type {SessionID}
   * @memberof SessionAggregatedParticipantData
   */
  sessionId: SessionID;
  /**
   *
   * @type {number}
   * @memberof SessionAggregatedParticipantData
   */
  speakingTime: number;
  /**
   *
   * @type {number}
   * @memberof SessionAggregatedParticipantData
   */
  averageEmotions: number;
  /**
   *
   * @type {number}
   * @memberof SessionAggregatedParticipantData
   */
  averageAttention: number;
}
/**
 *
 * @export
 * @interface SessionAggregatedParticipantDataResponse
 */
export interface SessionAggregatedParticipantDataResponse
  extends SessionResponseBase {
  /**
   *
   * @type {Array<SessionAggregatedParticipantData>}
   * @memberof SessionAggregatedParticipantDataResponse
   */
  data: Array<SessionAggregatedParticipantData>;
}
/**
 *
 * @export
 */
export type SessionID = number;
/**
 *
 * @export
 * @interface SessionParticipantsResponse
 */
export interface SessionParticipantsResponse extends SessionResponseBase {
  /**
   *
   * @type {Array<Participant>}
   * @memberof SessionParticipantsResponse
   */
  data?: Array<Participant>;
}
/**
 *
 * @export
 * @interface SessionResponseBase
 */
export interface SessionResponseBase {
  /**
   *
   * @type {string}
   * @memberof SessionResponseBase
   */
  timestamp: string;
  /**
   *
   * @type {number}
   * @memberof SessionResponseBase
   */
  status: number;
  /**
   *
   * @type {string}
   * @memberof SessionResponseBase
   */
  error?: string;
  /**
   *
   * @type {string}
   * @memberof SessionResponseBase
   */
  message?: string;
}
/**
 *
 * @export
 * @interface SessionsAttentionEventsResponse
 */
export interface SessionsAttentionEventsResponse extends SessionResponseBase {
  /**
   *
   * @type {Array<AttentionEvent>}
   * @memberof SessionsAttentionEventsResponse
   */
  data?: Array<AttentionEvent>;
}
/**
 *
 * @export
 * @interface SessionsEmotionEventsResponse
 */
export interface SessionsEmotionEventsResponse extends SessionResponseBase {
  /**
   *
   * @type {Array<EmotionsEvent>}
   * @memberof SessionsEmotionEventsResponse
   */
  data?: Array<EmotionsEvent>;
}
/**
 *
 * @export
 * @interface SessionsParticipationEventsResponse
 */
export interface SessionsParticipationEventsResponse
  extends SessionResponseBase {
  /**
   *
   * @type {Array<ParticipationEvent>}
   * @memberof SessionsParticipationEventsResponse
   */
  data?: Array<ParticipationEvent>;
}
/**
 *
 * @export
 * @interface SessionsResponse
 */
export interface SessionsResponse extends SessionResponseBase {
  /**
   *
   * @type {Array<Session>}
   * @memberof SessionsResponse
   */
  data?: Array<Session>;
}
/**
 *
 * @export
 * @interface SessionsSpeakingEventsResponse
 */
export interface SessionsSpeakingEventsResponse extends SessionResponseBase {
  /**
   *
   * @type {Array<SpeakingEvent>}
   * @memberof SessionsSpeakingEventsResponse
   */
  data?: Array<SpeakingEvent>;
}
/**
 *
 * @export
 * @interface SpeakingEvent
 */
export interface SpeakingEvent extends Event {}
/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   * @type {number}
   * @memberof User
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof User
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  role: string;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof User
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  surname: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  department: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  macAddress: string;
  /**
   *
   * @type {Client}
   * @memberof User
   */
  client?: Client;
}
/**
 *
 * @export
 * @interface UserResponse
 */
export interface UserResponse extends SessionResponseBase {
  /**
   *
   * @type {User}
   * @memberof UserResponse
   */
  data: User;
}
/**
 *
 * @export
 * @interface UsersResponse
 */
export interface UsersResponse extends SessionResponseBase {
  /**
   *
   * @type {Array<User>}
   * @memberof UsersResponse
   */
  data: Array<User>;
}
/**
 * CORSApi - fetch parameter creator
 * @export
 */
export const CORSApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionAggregatedOptions(options: any = {}): FetchArgs {
      const localVarPath = `/session/aggregated`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionAllOptions(options: any = {}): FetchArgs {
      const localVarPath = `/session/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionAttentionsOptions(options: any = {}): FetchArgs {
      const localVarPath = `/session/attentions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionEmotionsOptions(options: any = {}): FetchArgs {
      const localVarPath = `/session/emotions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {number} moderatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionModeratorModeratorIdOptions(
      moderatorId: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'moderatorId' is not null or undefined
      if (moderatorId === null || moderatorId === undefined) {
        throw new RequiredError(
          "moderatorId",
          "Required parameter moderatorId was null or undefined when calling sessionModeratorModeratorIdOptions."
        );
      }
      const localVarPath = `/session/moderator/{moderatorId}`.replace(
        `{${"moderatorId"}}`,
        encodeURIComponent(String(moderatorId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionParticipantsOptions(options: any = {}): FetchArgs {
      const localVarPath = `/session/participants`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionParticipationsOptions(options: any = {}): FetchArgs {
      const localVarPath = `/session/participations`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionSpeakingOptions(options: any = {}): FetchArgs {
      const localVarPath = `/session/speaking`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionUploadOptions(options: any = {}): FetchArgs {
      const localVarPath = `/session/upload`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersAllOptions(options: any = {}): FetchArgs {
      const localVarPath = `/users/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersCurrentOptions(options: any = {}): FetchArgs {
      const localVarPath = `/users/current`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "OPTIONS" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CORSApi - functional programming interface
 * @export
 */
export const CORSApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionAggregatedOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).sessionAggregatedOptions(
          options
        );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionAllOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).sessionAllOptions(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionAttentionsOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).sessionAttentionsOptions(
          options
        );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionEmotionsOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).sessionEmotionsOptions(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {number} moderatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionModeratorModeratorIdOptions(
      moderatorId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CORSApiFetchParamCreator(
        configuration
      ).sessionModeratorModeratorIdOptions(moderatorId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionParticipantsOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).sessionParticipantsOptions(
          options
        );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionParticipationsOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).sessionParticipationsOptions(
          options
        );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionSpeakingOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).sessionSpeakingOptions(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionUploadOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).sessionUploadOptions(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersAllOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).usersAllOptions(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersCurrentOptions(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        CORSApiFetchParamCreator(configuration).usersCurrentOptions(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * CORSApi - factory interface
 * @export
 */
export const CORSApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionAggregatedOptions(options?: any) {
      return CORSApiFp(configuration).sessionAggregatedOptions(options)(
        fetch,
        basePath
      );
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionAllOptions(options?: any) {
      return CORSApiFp(configuration).sessionAllOptions(options)(
        fetch,
        basePath
      );
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionAttentionsOptions(options?: any) {
      return CORSApiFp(configuration).sessionAttentionsOptions(options)(
        fetch,
        basePath
      );
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionEmotionsOptions(options?: any) {
      return CORSApiFp(configuration).sessionEmotionsOptions(options)(
        fetch,
        basePath
      );
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {number} moderatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionModeratorModeratorIdOptions(moderatorId: number, options?: any) {
      return CORSApiFp(configuration).sessionModeratorModeratorIdOptions(
        moderatorId,
        options
      )(fetch, basePath);
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionParticipantsOptions(options?: any) {
      return CORSApiFp(configuration).sessionParticipantsOptions(options)(
        fetch,
        basePath
      );
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionParticipationsOptions(options?: any) {
      return CORSApiFp(configuration).sessionParticipationsOptions(options)(
        fetch,
        basePath
      );
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionSpeakingOptions(options?: any) {
      return CORSApiFp(configuration).sessionSpeakingOptions(options)(
        fetch,
        basePath
      );
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionUploadOptions(options?: any) {
      return CORSApiFp(configuration).sessionUploadOptions(options)(
        fetch,
        basePath
      );
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersAllOptions(options?: any) {
      return CORSApiFp(configuration).usersAllOptions(options)(fetch, basePath);
    },
    /**
     * Enable CORS by returning correct headers
     * @summary CORS support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersCurrentOptions(options?: any) {
      return CORSApiFp(configuration).usersCurrentOptions(options)(
        fetch,
        basePath
      );
    },
  };
};

/**
 * CORSApi - object-oriented interface
 * @export
 * @class CORSApi
 * @extends {BaseAPI}
 */
export class CORSApi extends BaseAPI {
  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public sessionAggregatedOptions(options?: any) {
    return CORSApiFp(this.configuration).sessionAggregatedOptions(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public sessionAllOptions(options?: any) {
    return CORSApiFp(this.configuration).sessionAllOptions(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public sessionAttentionsOptions(options?: any) {
    return CORSApiFp(this.configuration).sessionAttentionsOptions(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public sessionEmotionsOptions(options?: any) {
    return CORSApiFp(this.configuration).sessionEmotionsOptions(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {number} moderatorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public sessionModeratorModeratorIdOptions(
    moderatorId: number,
    options?: any
  ) {
    return CORSApiFp(this.configuration).sessionModeratorModeratorIdOptions(
      moderatorId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public sessionParticipantsOptions(options?: any) {
    return CORSApiFp(this.configuration).sessionParticipantsOptions(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public sessionParticipationsOptions(options?: any) {
    return CORSApiFp(this.configuration).sessionParticipationsOptions(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public sessionSpeakingOptions(options?: any) {
    return CORSApiFp(this.configuration).sessionSpeakingOptions(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public sessionUploadOptions(options?: any) {
    return CORSApiFp(this.configuration).sessionUploadOptions(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public usersAllOptions(options?: any) {
    return CORSApiFp(this.configuration).usersAllOptions(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   * Enable CORS by returning correct headers
   * @summary CORS support
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CORSApi
   */
  public usersCurrentOptions(options?: any) {
    return CORSApiFp(this.configuration).usersCurrentOptions(options)(
      this.fetch,
      this.basePath
    );
  }
}
/**
 * SessionApi - fetch parameter creator
 * @export
 */
export const SessionApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get all session's attentions events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionAttentionEvents(
      sessionId?: SessionID,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/session/attentions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      if (sessionId !== undefined) {
        localVarQueryParameter["sessionId"] = sessionId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all session's emotions events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionEmotionEvents(
      sessionId?: SessionID,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/session/emotions`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      if (sessionId !== undefined) {
        localVarQueryParameter["sessionId"] = sessionId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all session participants
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionParticipants(
      sessionId?: SessionID,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/session/participants`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      if (sessionId !== undefined) {
        localVarQueryParameter["sessionId"] = sessionId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all session's participations events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionParticipationEvents(
      sessionId?: SessionID,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/session/participations`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      if (sessionId !== undefined) {
        localVarQueryParameter["sessionId"] = sessionId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all session's speaking events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionSpeakingEvents(
      sessionId?: SessionID,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/session/speaking`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      if (sessionId !== undefined) {
        localVarQueryParameter["sessionId"] = sessionId;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all client's sessions
     * @param {number} [from] session creationDate UNIX timestamp
     * @param {number} [to] session creationDate UNIX timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(from?: number, to?: number, options: any = {}): FetchArgs {
      const localVarPath = `/session/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      if (from !== undefined) {
        localVarQueryParameter["from"] = from;
      }

      if (to !== undefined) {
        localVarQueryParameter["to"] = to;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get aggregated participant data by sessions
     * @param {number} [sid] sessions ID array
     * @param {number} [from] session creationDate UNIX timestamp
     * @param {number} [to] session creationDate UNIX timestamp
     * @param {number} [ageFrom] years
     * @param {number} [ageTo] years
     * @param {number} [ethnicity] ethnicity enum
     * @param {number} [gender] 1 - Male, 2 - Female
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsAggregatedData(
      sid?: number,
      from?: number,
      to?: number,
      ageFrom?: number,
      ageTo?: number,
      ethnicity?: number,
      gender?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/session/aggregated`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      if (sid !== undefined) {
        localVarQueryParameter["sid"] = sid;
      }

      if (from !== undefined) {
        localVarQueryParameter["from"] = from;
      }

      if (to !== undefined) {
        localVarQueryParameter["to"] = to;
      }

      if (ageFrom !== undefined) {
        localVarQueryParameter["ageFrom"] = ageFrom;
      }

      if (ageTo !== undefined) {
        localVarQueryParameter["ageTo"] = ageTo;
      }

      if (ethnicity !== undefined) {
        localVarQueryParameter["ethnicity"] = ethnicity;
      }

      if (gender !== undefined) {
        localVarQueryParameter["gender"] = gender;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all sessions owned by moderator
     * @param {number} moderatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsByModerator(moderatorId: number, options: any = {}): FetchArgs {
      // verify required parameter 'moderatorId' is not null or undefined
      if (moderatorId === null || moderatorId === undefined) {
        throw new RequiredError(
          "moderatorId",
          "Required parameter moderatorId was null or undefined when calling getSessionsByModerator."
        );
      }
      const localVarPath = `/session/moderator/{moderatorId}`.replace(
        `{${"moderatorId"}}`,
        encodeURIComponent(String(moderatorId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Uploads a session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionData(options: any = {}): FetchArgs {
      const localVarPath = `/session/upload`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SessionApi - functional programming interface
 * @export
 */
export const SessionApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all session's attentions events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionAttentionEvents(
      sessionId?: SessionID,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<SessionsAttentionEventsResponse> {
      const localVarFetchArgs = SessionApiFetchParamCreator(
        configuration
      ).getSessionAttentionEvents(sessionId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get all session's emotions events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionEmotionEvents(
      sessionId?: SessionID,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<SessionsEmotionEventsResponse> {
      const localVarFetchArgs = SessionApiFetchParamCreator(
        configuration
      ).getSessionEmotionEvents(sessionId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get all session participants
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionParticipants(
      sessionId?: SessionID,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<SessionParticipantsResponse> {
      const localVarFetchArgs = SessionApiFetchParamCreator(
        configuration
      ).getSessionParticipants(sessionId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get all session's participations events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionParticipationEvents(
      sessionId?: SessionID,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<SessionsParticipationEventsResponse> {
      const localVarFetchArgs = SessionApiFetchParamCreator(
        configuration
      ).getSessionParticipationEvents(sessionId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get all session's speaking events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionSpeakingEvents(
      sessionId?: SessionID,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<SessionsSpeakingEventsResponse> {
      const localVarFetchArgs = SessionApiFetchParamCreator(
        configuration
      ).getSessionSpeakingEvents(sessionId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get all client's sessions
     * @param {number} [from] session creationDate UNIX timestamp
     * @param {number} [to] session creationDate UNIX timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      from?: number,
      to?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<SessionsResponse> {
      const localVarFetchArgs = SessionApiFetchParamCreator(
        configuration
      ).getSessions(from, to, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get aggregated participant data by sessions
     * @param {number} [sid] sessions ID array
     * @param {number} [from] session creationDate UNIX timestamp
     * @param {number} [to] session creationDate UNIX timestamp
     * @param {number} [ageFrom] years
     * @param {number} [ageTo] years
     * @param {number} [ethnicity] ethnicity enum
     * @param {number} [gender] 1 - Male, 2 - Female
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsAggregatedData(
      sid?: number,
      from?: number,
      to?: number,
      ageFrom?: number,
      ageTo?: number,
      ethnicity?: number,
      gender?: number,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<SessionAggregatedParticipantDataResponse> {
      const localVarFetchArgs = SessionApiFetchParamCreator(
        configuration
      ).getSessionsAggregatedData(
        sid,
        from,
        to,
        ageFrom,
        ageTo,
        ethnicity,
        gender,
        options
      );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get all sessions owned by moderator
     * @param {number} moderatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsByModerator(
      moderatorId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<SessionsResponse> {
      const localVarFetchArgs = SessionApiFetchParamCreator(
        configuration
      ).getSessionsByModerator(moderatorId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Uploads a session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionData(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<DefaultResponseData> {
      const localVarFetchArgs =
        SessionApiFetchParamCreator(configuration).uploadSessionData(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * SessionApi - factory interface
 * @export
 */
export const SessionApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Get all session's attentions events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionAttentionEvents(sessionId?: SessionID, options?: any) {
      return SessionApiFp(configuration).getSessionAttentionEvents(
        sessionId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get all session's emotions events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionEmotionEvents(sessionId?: SessionID, options?: any) {
      return SessionApiFp(configuration).getSessionEmotionEvents(
        sessionId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get all session participants
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionParticipants(sessionId?: SessionID, options?: any) {
      return SessionApiFp(configuration).getSessionParticipants(
        sessionId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get all session's participations events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionParticipationEvents(sessionId?: SessionID, options?: any) {
      return SessionApiFp(configuration).getSessionParticipationEvents(
        sessionId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get all session's speaking events
     * @param {SessionID} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionSpeakingEvents(sessionId?: SessionID, options?: any) {
      return SessionApiFp(configuration).getSessionSpeakingEvents(
        sessionId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get all client's sessions
     * @param {number} [from] session creationDate UNIX timestamp
     * @param {number} [to] session creationDate UNIX timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(from?: number, to?: number, options?: any) {
      return SessionApiFp(configuration).getSessions(
        from,
        to,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get aggregated participant data by sessions
     * @param {number} [sid] sessions ID array
     * @param {number} [from] session creationDate UNIX timestamp
     * @param {number} [to] session creationDate UNIX timestamp
     * @param {number} [ageFrom] years
     * @param {number} [ageTo] years
     * @param {number} [ethnicity] ethnicity enum
     * @param {number} [gender] 1 - Male, 2 - Female
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsAggregatedData(
      sid?: number,
      from?: number,
      to?: number,
      ageFrom?: number,
      ageTo?: number,
      ethnicity?: number,
      gender?: number,
      options?: any
    ) {
      return SessionApiFp(configuration).getSessionsAggregatedData(
        sid,
        from,
        to,
        ageFrom,
        ageTo,
        ethnicity,
        gender,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Get all sessions owned by moderator
     * @param {number} moderatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsByModerator(moderatorId: number, options?: any) {
      return SessionApiFp(configuration).getSessionsByModerator(
        moderatorId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @summary Uploads a session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionData(options?: any) {
      return SessionApiFp(configuration).uploadSessionData(options)(
        fetch,
        basePath
      );
    },
  };
};

/**
 * SessionApi - object-oriented interface
 * @export
 * @class SessionApi
 * @extends {BaseAPI}
 */
export class SessionApi extends BaseAPI {
  /**
   *
   * @summary Get all session's attentions events
   * @param {SessionID} [sessionId] Session ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  public getSessionAttentionEvents(sessionId?: SessionID, options?: any) {
    return SessionApiFp(this.configuration).getSessionAttentionEvents(
      sessionId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get all session's emotions events
   * @param {SessionID} [sessionId] Session ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  public getSessionEmotionEvents(sessionId?: SessionID, options?: any) {
    return SessionApiFp(this.configuration).getSessionEmotionEvents(
      sessionId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get all session participants
   * @param {SessionID} [sessionId] Session ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  public getSessionParticipants(sessionId?: SessionID, options?: any) {
    return SessionApiFp(this.configuration).getSessionParticipants(
      sessionId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get all session's participations events
   * @param {SessionID} [sessionId] Session ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  public getSessionParticipationEvents(sessionId?: SessionID, options?: any) {
    return SessionApiFp(this.configuration).getSessionParticipationEvents(
      sessionId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get all session's speaking events
   * @param {SessionID} [sessionId] Session ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  public getSessionSpeakingEvents(sessionId?: SessionID, options?: any) {
    return SessionApiFp(this.configuration).getSessionSpeakingEvents(
      sessionId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get all client's sessions
   * @param {number} [from] session creationDate UNIX timestamp
   * @param {number} [to] session creationDate UNIX timestamp
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  public getSessions(from?: number, to?: number, options?: any) {
    return SessionApiFp(this.configuration).getSessions(
      from,
      to,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get aggregated participant data by sessions
   * @param {number} [sid] sessions ID array
   * @param {number} [from] session creationDate UNIX timestamp
   * @param {number} [to] session creationDate UNIX timestamp
   * @param {number} [ageFrom] years
   * @param {number} [ageTo] years
   * @param {number} [ethnicity] ethnicity enum
   * @param {number} [gender] 1 - Male, 2 - Female
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  public getSessionsAggregatedData(
    sid?: number,
    from?: number,
    to?: number,
    ageFrom?: number,
    ageTo?: number,
    ethnicity?: number,
    gender?: number,
    options?: any
  ) {
    return SessionApiFp(this.configuration).getSessionsAggregatedData(
      sid,
      from,
      to,
      ageFrom,
      ageTo,
      ethnicity,
      gender,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Get all sessions owned by moderator
   * @param {number} moderatorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  public getSessionsByModerator(moderatorId: number, options?: any) {
    return SessionApiFp(this.configuration).getSessionsByModerator(
      moderatorId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @summary Uploads a session
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionApi
   */
  public uploadSessionData(options?: any) {
    return SessionApiFp(this.configuration).uploadSessionData(options)(
      this.fetch,
      this.basePath
    );
  }
}
/**
 * UsersApi - fetch parameter creator
 * @export
 */
export const UsersApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get all current user info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentUser(options: any = {}): FetchArgs {
      const localVarPath = `/users/current`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all users of the current organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTeamUsers(options: any = {}): FetchArgs {
      const localVarPath = `/users/all`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication basicAuth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarHeaderParameter["Authorization"] =
          "Basic " +
          btoa(configuration.username + ":" + configuration.password);
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all current user info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentUser(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<UserResponse> {
      const localVarFetchArgs =
        UsersApiFetchParamCreator(configuration).getCurrentUser(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @summary Get all users of the current organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTeamUsers(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<UsersResponse> {
      const localVarFetchArgs =
        UsersApiFetchParamCreator(configuration).getTeamUsers(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Get all current user info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentUser(options?: any) {
      return UsersApiFp(configuration).getCurrentUser(options)(fetch, basePath);
    },
    /**
     *
     * @summary Get all users of the current organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTeamUsers(options?: any) {
      return UsersApiFp(configuration).getTeamUsers(options)(fetch, basePath);
    },
  };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   *
   * @summary Get all current user info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public getCurrentUser(options?: any) {
    return UsersApiFp(this.configuration).getCurrentUser(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @summary Get all users of the current organisation
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public getTeamUsers(options?: any) {
    return UsersApiFp(this.configuration).getTeamUsers(options)(
      this.fetch,
      this.basePath
    );
  }
}
